import { render, staticRenderFns } from "./appr-generalwork.vue?vue&type=template&id=2e7fe44c&scoped=true"
import script from "./appr-generalwork.vue?vue&type=script&lang=js"
export * from "./appr-generalwork.vue?vue&type=script&lang=js"
import style0 from "./appr-generalwork.vue?vue&type=style&index=0&id=2e7fe44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7fe44c",
  null
  
)

export default component.exports